import { memo, useCallback } from 'react';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useDispatch, useSelector } from 'react-redux';
import FJObjectEraseRight from '../view/FJObjectEraseRight';
import FJActionObjectErase from '../../../../redux/action/FJActionObjectErase';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import FJActionCommon from '../../../../redux/action/FJActionCommon';
import { useState } from 'react';

const FJObjectEraseRightContainer = memo(function FJObjectEraseRightContainer() {
    useLocalStore();
    const dispatch = useDispatch();

    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const curMenuIndex = useSelector(state => state.objectErase.curMenuIndex);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const [downloadLoading, setDownloadLoading] = useState(false);

    const hasEditImage = useSelector(state => {
        const editImage = state.brushEditCommon.editImage;
        return editImage && editImage.src && editImage.src !== '';
    });
    const isCanDownload = useSelector(state => {
        const { editImage, originImage } = state.brushEditCommon;
        const isDone = state.common.isDone;
        const curMenuIndex = state.objectErase.curMenuIndex;

        if (curMenuIndex === 1) {
            return isDone;
        }

        return originImage && editImage && originImage.src !== editImage.src;
    });

    const _setIsDraggingFile = useCallback(
        value => {
            dispatch(setSliceIsDraggingFileAction(value));
        },
        [dispatch],
    );

    const uploadImg = useCallback(
        file => {
            if (curMenuIndex === 1) {
                dispatch(FJActionObjectErase.uploadTextEraseImageAction(file));
            } else {
                dispatch(FJActionObjectErase.uploadImageAction(file));
            }
        },
        [dispatch, curMenuIndex],
    );

    const download = useCallback(() => {
        setDownloadLoading(true);
        dispatch(FJActionObjectErase.downloadImageAction(() => setDownloadLoading(false)));
    }, [dispatch]);

    const imageToVideo = useCallback(() => {
        dispatch(FJActionCommon.imageToVideoAction());
    }, [dispatch]);

    return (
        <FJObjectEraseRight
            curMenuIndex={curMenuIndex}
            setIsDraggingFile={_setIsDraggingFile}
            uploadImg={uploadImg}
            headerTabIndex={headerTabIndex}
            taskStatus={taskStatus}
            downloadEditImageLoading={downloadLoading}
            isCanDownload={isCanDownload}
            download={download}
            hasEditImage={hasEditImage}
            imageToVideo={imageToVideo}
        />
    );
});

export default FJObjectEraseRightContainer;
